import { Input, message, Tag, Tooltip } from 'antd'
import _ from 'lodash'
import React from 'react'
import { Icon } from 'xadmin-ui'


const changeValue = (value) => {
  if (value) {
    return value
  }
  return []
}
const changeInput = (value) => {
  return value
}

class TagComponent extends React.Component {
  state = {
    inputVisible: false,
    inputValue: '',
  };

  handleClose = (removedTag) => {
    const { value, onChange } = this.props
    const tags = changeValue(value)
    const v = tags.filter(tag => tag !== removedTag)
    onChange(changeInput(v))
  }

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  }

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value })
  }

  handleInputConfirm = () => {
    const { value, onChange } = this.props
    let tags = changeValue(value)
    const { inputValue } = this.state

    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [ ...tags, inputValue ]
    } else if (!_.isEmpty(inputValue)) {
      message.warning('标签已存在!')
    }

    this.setState({
      inputVisible: false,
      inputValue: '',
    }, () => {
      onChange(changeInput(tags))
    })
  }

  saveInputRef = input => this.input = input

  render() {
    const { value } = this.props
    const { inputVisible, inputValue } = this.state
    const tags = changeValue(value)
    return (
      <div>
        {tags.map((tag, index) => {
          const isLongTag = tag.length > 20;
          const tagElem = (
            <Tag key={tag} closable={true} onClose={() => this.handleClose(tag)}
              style={{ height: 34, lineHeight: '34px', fontSize: 14 }}>
              {isLongTag ? `${tag.slice(0, 20)}...` : tag}
            </Tag>
          )
          return isLongTag ? <Tooltip title={tag} key={tag}>{tagElem}</Tooltip> : tagElem
        })}
        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && (
          <Tag
            onClick={this.showInput}
            style={{  borderStyle: 'dashed', height: 34, lineHeight: '34px', fontSize: 14 }}
          ><Icon type="plus" />添加新标签</Tag>
        )}
      </div>
    )
  }
}

class FormTag extends React.Component {
  render() {
    const { input: { name, value, onChange }, label, meta, field } = this.props
    return <TagComponent onChange={onChange} value={value} />
  }
}

export default FormTag
